import script from "./ThePendingTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./ThePendingTransaction.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./ThePendingTransaction.vue?vue&type=style&index=0&id=a46c66a0&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__